// Accès API des écrans de service (cuisine, caisse, serveur).
// Ces écrans utilisent la session du restaurateur : on connecte chaque
// tablette une fois avec le mot de passe admin, elle reste connectée.

import { API_URL, getAdminToken, clearAdminToken } from './api';

export const getServiceToken = () => getAdminToken();

export const staffFetch = async (path, options = {}, onUnauthorized) => {
  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
      Authorization: `Bearer ${getAdminToken()}`
    }
  });

  if (response.status === 401 && onUnauthorized) {
    clearAdminToken();
    onUnauthorized();
  }

  return response;
};
